import {useSelector} from "react-redux";
import {selectUserNodeIdentity} from "joynt/state/selectors/joint";

export function useCurrentIdentity(nodeId) {
    return useSelector(store=>selectUserNodeIdentity(store, nodeId));
}